const token = localStorage.user
import request from "../utils/request.js"
import { post } from "@/api/requrestHttp"

const work_dc_recordsUrl = "/ypt/admin/order/findOrderByPerson"
// 学习教育 按类别统计
export const findLearnTeachStatistics = data =>
  request({
    url: "/admin/learnTeach/info/findLearnTeachStatistics",
    method: "post",
    data
  })

// 按类别统计
export const findCarryOutStatistics = () =>
  request({
    url: "/admin/learnTeach/info/findCarryOutStatistics",
    method: "post",
    data: ""
  })
//转fd格式
function changeInfor(data) {
  let fd = new FormData()
  for (let key in data) {
    fd.append(key, data[key])
  }
  return fd
}
//投诉与建议 获取列表信息
function getAdviceInfor(data) {
  return post("/admin/complaintSuggestion/info/findComplaintSuggestion", data)
}
//协商组织 社区共治委员会
function addPersonList(data) {
  return post("admin/consulType/info/batchUpdate", data)
}
function deletePerson(data) {
  return post("admin/consulType/info/insertConsultPerson", data)
}

//志愿服务 获取党员列表
function getMemberInfor(data) {
  return post("/admin/organization/info/findOrganization", data)
}

//党建首页-下面三个echarts数据
//年龄结构
function getNljgEcharts(data) {
  return post("/djyl/admin/partyMemberArchives/info/findPartyAgeStructure", data)
}
//活动参与情况
function getCyqkEcharts(data) {
  return post(
    "/djyl/admin/partyMemberArchives/info/findPartyActivistsStatistics",
    data
  )
}
//数量统计
function getSltjEcharts(data) {
  return post(
    "/djyl/admin/partyMemberArchives/info/findPartyNumbersStatistics",
    data
  )
}
//文体中心 列表
function getWtzxTable(data) {
  return post("/admin/stylistic/info/listStylisticCenter", data)
}
//文体中心 新增
function addWtzxInform(data) {
  return post("/admin/stylistic/info/insertStylisticCenter", data)
}
//文体中心 修改
function editorWtzxInform(data) {
  return post("/admin/stylistic/info/updtateStylisticCenter", data)
}
//文体中心 查看/修改
function lookWtzxInform(data) {
  return post("/admin/stylistic/info/getStylisticCenter", data)
}
//文体中心 审核
function auditWtzxInform(data) {
  return post("/admin/stylistic/info/examineStylisticCenter", data)
}
//文体中心 上架、下架
function upWtzxInform(data) {
  return post("/admin/stylistic/info/examineStylisticCenter", data)
}
//文体中心 删除
function deleteWtzxInform(data) {
  return post("/admin/stylistic/info/deleteStylisticCenter", data)
}

//网格导出
function getDaochuInform(data) {
  return post("/admin/person/info/downloadPersonExcel", data)
}
function downloadPartyExcel(data) {
  return request({
    url: "/admin/person/info/downloadPersonExcel",
    method: "POST",
    data: data,
    responseType: "blob"
  })
}
//网格工作 => 证明开具
function getZmkjList(data) {
  return post("/rbac/admin/org/info/OrgTreelist", data)
}
const work_dc_records = data => post(work_dc_recordsUrl, data) //组织机构-订餐管理-订餐记录接口
export {
  work_dc_records,
  getAdviceInfor,
  changeInfor,
  getMemberInfor,
  getNljgEcharts,
  getCyqkEcharts,
  getSltjEcharts,
  getWtzxTable,
  addWtzxInform,
  editorWtzxInform,
  lookWtzxInform,
  auditWtzxInform,
  upWtzxInform,
  deleteWtzxInform,
  downloadPartyExcel,
  getZmkjList,
  addPersonList,
  deletePerson
}
